import React, { Fragment } from 'react';

import * as Actions from 'subaccounts/components/list/actions';

const SubaccountsActions = ({ permissions, subaccount, company, subcompany, handleToggle }) => {
  return (
    <Fragment>
      {permissions['acl.accounts.toggle'] && (
        <Actions.Toggle subaccount={subaccount} handleClick={handleToggle} />
      )}
      {permissions['acl.accounts.update'] && (
        <Actions.Edit subaccount={subaccount} company={company} subcompany={subcompany} />
      )}
    </Fragment>
  );
};

export default SubaccountsActions;



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/components/list/SubaccountsActions.js